import React, {useState} from "react";
import Link from "gatsby-link";
import styled, { injectGlobal } from "styled-components";
import Slider from "react-slick"
import slickStyles01 from "slick-carousel/slick/slick.css"
import slickStyles02 from "slick-carousel/slick/slick-theme.css"
import customArrow from '../svg/right-circle.svg'
import downCircleWhite from '../svg/right-circle-white.svg'
import * as vars from "../style/vars";
import { above, below } from "../style/functions";
import { RichText, Date } from 'prismic-reactjs';

const Photo = ({ slides, pauseOnHover=false, autoplay, fixText, hero, dots = true, theme, mini = false }) => {
   const [autoplaying, setAutoplaying] = useState(autoplay)

   const pause = () => {
      setAutoplaying(false)
   }
   
   var settings = {
      fade: true,
      infinite: true,
      speed: 2000,
      slidesToShow: 1,
      slidesToScroll: 1,
      // autoplay: autoplay,
      autoplaySpeed: 4000,
      pauseOnHover: pauseOnHover,
      dots: dots,
      waitForAnimate: false,
   };

   const onClickScroll = () => {
      if (typeof window !== `undefined`) {
         let scrollDistance = window.pageYOffset
         window.scrollTo({
            top: scrollDistance + window.innerHeight,
            behavior: "smooth"
         })
      }
   }

   return (
      <Container isHero={hero} mini={mini} onClick={pause}>
         <Slider autoplay={autoplaying} {...settings} className="slider" >
            {slides
               .map((slide, index) => (
                  <Slide key={index} className='theSlide'>
                     <div className="slideCaption">
                        {slide['header']
                        ?
                        <div className="slideTitle">{slide['header'][0].text}</div>
                        :
                           ''
                        }
                        {slide['subheader']
                        ?
                           <div className="slideSubTitle">{slide['subheader'][0].text}</div>
                        :
                           ''
                        }
                     </div>
                     <picture className={"anchor-" + slide.image_anchor}>
                        <source srcSet={slide['img'][0]['mobile'][0]['url']}
                           media="(max-width: 840px)" />
                        <img src={slide['img'][0]['url']} alt={slide['img'][0]['alt']} draggable={false} />
                     </picture>
                  </Slide>
               ))}
         </Slider>
      </Container >
   );
};

injectGlobal`
   ${slickStyles01}
   ${slickStyles02}
`

const Container = styled.div`
   padding: 0;
   position: relative;
   width: ${props => props.isHero ? '100%' : '94%'};
   margin: auto;
   padding-bottom: ${vars.padding.inner * 2}rem;
	 ${below.tablet`
	 	padding-bottom: 0;
	 `}
	 ${props => !props.isHero && below.tablet`
	 	.grid{
			 padding-left: 0;
			 padding-right: 0;
		 }
	 `};
	 ${props => props.mini && below.mobile`
		 img, source{
			 height: auto !important;
			 min-height: none !important;
		 }
		//  .slick-arrow{
		// 	 display: none !important;
		//  }
		//  .slick-dots{
		// 	 left: 0 !important;
		// 	 transform: none !important;
		//  }
		 .slick-dots li{
			 margin: 0;
			 &.slick-active button:before{
				background: #3f3e3e !important;
            opacity: 1;
			}
		 }
		 .slick-dots li button{
			 border: 1px solid #3f3e3e !important;

		 }
		 .slick-dots li button, .slick-dots li button:after, .slick-dots li button:before {
			 width: 12px !important;
			 height: 12px !important;
		 }
	 `};
   .slick-arrow {
      width: auto;
      height: auto;
      /* top: 80vmin; */
      /* bottom: auto; */
      /* left: auto; */
      right: auto;
      margin: 0 4vw;
      z-index: 3;

      &:hover {
         opacity: 1;
      }
      &:before {
         content: '';
         display: block;
         width: 8vw;
         max-width: 3.5rem;
         height: 8vw;
         max-height: 3.5rem;
         background: url(${downCircleWhite}) no-repeat;
      }

      ${below.tablet`
         // top: 80vmin;
         // margin: 0 1vw;
         top:auto;
         bottom:20px;
         transform:none;
         margin:0;
      `};
   }

   .slick-prev {
      right: 5rem;
      &:before {
         transform: scaleX(-1);
      }
      ${below.tablet`
         left: 20px;
      `};
   }

   .slick-next {
      right: 0;
      ${below.tablet`
         left: 50px;
      `};
   }
	 .slick-dots {
      margin-left: 17rem;
      bottom: 9%;
      width: auto;
      list-style: none;
      text-align: center;
      li {

			 button {
         background: transparent;
         border: 1px solid white;
         border-radius: 50%;
				 width:20px;
				 height:20px;
				 &:before, &:after{
					width:20px;
				 height:20px;
				 }
         :hover:before {
            background: white;
            opacity: 1;
         }
         :before {
            content: '';
            background-color: white;
            border-radius: 50%;
            opacity: 0;
            transition: opacity .5s;
         }
      }
			&.slick-active button:before{
				background: white;
            opacity: 1;
			}
	 }

      ${below.tablet`
         margin: 0;
         left: 50%;
         bottom: 3%;
         bottom: 20px;
         transform: translateX(-50%);
      `}
   }

   h3 {
		font-family: ${vars.fonts.main};
		font-weight:normal;

		font-size:2.3rem;
		font-weight: normal;
		${below.tablet`
			font-size:2.3rem;
		`}
		${below.mobile`
			font-size:2rem;
		`}
      padding-bottom: ${vars.padding.mobInner}rem;
   }
	 .grid .col{
		 min-height: 30rem;
		 ${below.tablet`
		 	min-height: 0;
			 padding-left: ${vars.padding.mobInner}rem;
			 border-left: 1px solid ${vars.colors.body};

		 `}
	 }
   .grid .col:first-of-type {
      border-left: 1px solid ${vars.colors.body};
			padding-left: ${vars.padding.inner}rem;
			${below.tablet`
				padding-left: ${vars.padding.mobInner}rem;
			`}
   }

   .border-left {
      border-left: 1px solid ${vars.colors.body};
			padding-left: ${vars.padding.inner}rem;
   }
   .mob-border-left {
      border-left-width: 0;
			padding-left: ${vars.padding.inner}rem;

      ${below.tablet`
         border-left-width: 0.2rem;
      `}
   }

   ${below.tablet`
      margin-bottom: ${vars.padding.inner * 3}vmin;
   `}
`

const Slide = styled.div`
   // margin-bottom: ${vars.padding.inner}rem;
   img, source {
      width: 100%;
      height: 70vh;
      min-height: 35rem;
      object-fit: cover;

      ${above.l`
         height: 85vh;
      `};

      ${above.giant`
         height: 90vh;
      `};
   }
	 .anchor-Bottom {
      img, source {
         object-position: bottom;
      }
	 }
   .anchor-Top {
      img, source {
         object-position: top;
      }
   }
   .anchor-Center {
      img, source {
         object-position: center;
      }
   }
   .slideCaption{
      position:absolute;
      bottom:0;
      left:0;
      bottom: 47px;
    left: 83px;
      ${below.tablet`
         bottom: 20%;
         left: 20px;
         right:20px;
      `};

   }

   .slideTitle {
      letter-spacing: .03rem;
      font-family: 'CaslonGraD',Times,serif;
      font-weight: normal;
      font-size: 5.7rem;
      line-height: 1;
      color:#fff;
      white-space: pre-line;
      padding-bottom:.28em;
      ${below.tablet`
      font-size: 4rem;
      `};
      ${below.mobile`
      font-size: 2.6rem;
      `};

  }
   .slideSubTitle{
      font-size: 2.1rem;
      line-height: 1.4;
      letter-spacing: 0.05em;
      color:#fff;
      white-space: pre-line;

      ${below.tablet`
      font-size: 1.9rem;
      `};
      ${below.mobile`
      font-size: 1.6rem;
      white-space: normal;
      `};
   }
   // ${below.tablet`
   //    margin-bottom: ${vars.padding.inner * 3}vmin;
   // `}
`

const MainCopy = styled.div`
   padding-bottom: ${vars.padding.inner}rem;
   padding-right: ${vars.padding.inner}rem;
   border-right: ${props => props.isHero ? '1' : '1'}px solid ${vars.colors.body};
	img{
		width: 200px;
	}
   ${below.tablet`
      padding-bottom: 0;
      border-right: none;
   `};

`

const Text = styled.div`
   padding-left: ${vars.padding.inner}rem;

   ${below.tablet`
      border-left: none;
      padding-left: 0;
   `};

   h4 {
      padding-bottom: 3rem;
   }
   h5 {
      font-size: ${vars.padding.inner / 2}rem;
      padding-bottom: ${vars.padding.inner / 5}rem;

   }
`

const BookNow = styled(Link)`
   white-space: nowrap;
   background: white;
   padding: 1.2rem 1.75rem;
   border-radius: 4px;
   text-decoration: none;
   border-radius: 4px;
   border: ${props => props.theme !== 'white' ? 'inherit' : `1px solid #e0e0e0`};

   &.btn-square {
      display: inline-block;
      width: auto;
      font-size: 2.2rem;

      &:hover {
         margin: 0;
         &:after {
            margin-left: 1rem;
         }
      }

      &:after {
         content: '→';
         margin-left: .6rem;
         transition: margin-left .3s;
      }

      ${below.tablet`
         font-size: 1.4rem;
      `};
   }
`

const DownArrow = styled.div`
   display: ${props => props.isHero ? 'block' : 'none'};
   position: absolute;
   top: 60vmin;
   width: 3rem;
   height: 3rem;

   &:after {
      position: absolute;
      display: inline-block;
      content: "";
      width: 4rem;
      height: 4rem;
      background: url(${downCircleWhite});
      transform: rotate(90deg);
      vertical-align: middle;
      cursor: pointer;
   }

   ${below.tablet`
      visibility: hidden;
   `};

`


export default Photo;



// WEBPACK FOOTER //
// ./src/components/photo_product.js